function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar-day-schedule-wrong-event"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16 20h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26 20h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 28h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40 28h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 30h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26 30h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.006 37a1 1 0 0 0 -1-1h-2.006v-4h4v1.965a1 1 0 0 0 2 0v-2.965a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h3.006a1 1 0 0 0 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 40h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26 40h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4v-4h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54 33.74v-24.74a3.009 3.009 0 0 0 -3-3h-5v-1a3 3 0 0 0 -6 0v1h-24v-1a3 3 0 0 0 -6 0v1h-5a3.009 3.009 0 0 0 -3 3v42a3.009 3.009 0 0 0 3 3h28.74a15 15 0 1 0 20.26-20.26zm-12-28.74a1 1 0 0 1 2 0v4a1 1 0 0 1 -2 0zm-30 0a1 1 0 0 1 2 0v4a1 1 0 0 1 -2 0zm-8 4a1 1 0 0 1 1-1h5v1a3 3 0 0 0 6 0v-1h24v1a3 3 0 0 0 6 0v-1h5a1 1 0 0 1 1 1v5h-48zm28.88 43h-27.88a1 1 0 0 1 -1-1v-35h48v16.88a14.807 14.807 0 0 0 -5-.88 15.018 15.018 0 0 0 -15 15 14.807 14.807 0 0 0 .88 5zm14.12 8a13 13 0 1 1 13-13 13.012 13.012 0 0 1 -13 13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m53.364 40.636a1 1 0 0 0 -1.414 0l-4.95 4.95-4.95-4.95a1 1 0 0 0 -1.414 1.414l4.95 4.95-4.95 4.95a1 1 0 1 0 1.414 1.414l4.95-4.95 4.95 4.95a1 1 0 0 0 1.414-1.414l-4.95-4.95 4.95-4.95a1 1 0 0 0 0-1.414z"
}));

var SvgCalendarErr = function SvgCalendarErr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarErr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_err.c3808695.svg";
export { ForwardRef as ReactComponent };